var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7045 0.962767C14.5995 0.980272 14.4944 1.03279 14.4069 1.0853L11.6761 2.66079V6.72205L14.4244 8.29754C14.9321 8.59513 15.5623 8.42008 15.8599 7.91242C15.9474 7.75487 15.9999 7.57982 15.9999 7.38726V1.97808C15.9999 1.33038 15.3872 0.805218 14.7045 0.962767Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2494 0H1.75054C0.787745 0 0 0.787745 0 1.75054V7.64988C0 8.61268 0.787745 9.40042 1.75054 9.40042H10.2494C11.2122 9.40042 12 8.61268 12 7.64988V1.75054C12 0.77024 11.2122 0 10.2494 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUnmute);
export default __webpack_public_path__ + "static/media/video-unmute.44f16042480be36a8fd723f21d5003db.svg";
export { ForwardRef as ReactComponent };